<div class="d-flex flex-column" *transloco="let t">
  <cw-banner
    class="mt-m"
    type="warning"
    [description]="bannerDescription"
    [enableClose]="false"
  />

  @if (!switchViewSidebarTabStore.loading() && noCustomersAvailable()) {
    <cw-banner
      class="mt-m"
      type="info"
      [description]="t('No online customers available.')"
      [enableClose]="false"
    />
  }

  <h5 class="mb-m">{{ t('Please select why you need to proceed.') }}</h5>

  <mat-radio-group aria-label="Select a reason" [formControl]="reasonControl"
    data-cy="select-a-reason-radio-group">
    @for (reason of reasons; track reason.value; let isFirst = $first) {
      <mat-radio-button
        class="d-block"
        [class.mt-s]="!isFirst"
        [value]="reason.value"
        data-cy="value-radio-option">{{ t(reason.labelKey) }}
      </mat-radio-button>
    }
  </mat-radio-group>

  <app-country-customer-selection
    [countryControl]="countryControl"
    [customerControl]="customerControl"
    [disableCustomerInput]="noCustomersAvailable()"
    [filteredCustomers]="switchViewSidebarTabStore.getFilteredCustomers()"
    [selectedCustomer]="this.switchViewSidebarTabStore.selectedCustomer()"/>
</div>
<app-sidebar-heartbeat [isLoading]="switchViewSidebarTabStore.loading()"/>
